export default function EntityUsersTableHeader() {
  return (
    <div className="border-1 border-gray flex border-b px-0 py-2 text-left">
      <div className="block w-[20%] font-bold"><h2 className="text-sm">Name</h2></div>
      <div className="block w-[24%] font-bold"><h2 className="text-sm text-center">Email Address</h2></div>
      <div className="block w-[20%] font-bold"><h2 className="text-sm text-center">Phone Number</h2></div>
      <div className="block w-[16%] font-bold"><h2 className="text-sm text-center">Role</h2></div>
      <div className="block w-[20%] font-bold"><h2 className="text-sm text-center">Permissions</h2></div>
    </div>
  );
}
